import gql from 'graphql-tag';
import { DEAL_SMS_ACTIVITY_FRAGMENT } from './fragments/dealSmsActivity.fragment';

export const SMS_CONVERSATION = gql`
  query SmsConversation($input: SmsActivityListByVoInput!) {
    messaging {
      smsActivities(input: $input) {
        error
        success
        list {
          ...DealSmsActivityFields
          __typename
        }
      }
    }
  }
  ${DEAL_SMS_ACTIVITY_FRAGMENT}
`;
